<mat-tab-group mat-stretch-tabs class="resume-tabs">
  <mat-tab label="Ultimos 5 creados">
    <alert-last-created></alert-last-created>
  </mat-tab>
  <!-- <mat-tab label="Ultimos 5 asignados">
    <alert-last-assigned></alert-last-assigned>
  </mat-tab> -->

  <mat-tab label="Ultimos 5 asignados">
    <last-cases-assigned></last-cases-assigned>
  </mat-tab>
  <mat-tab label="Ultimos 5 en proceso">
    <last-cases-running></last-cases-running>
  </mat-tab>
  <mat-tab label="Ultimos 5 por aprobar">
    <last-cases-tobeapproved></last-cases-tobeapproved>
  </mat-tab>
  <mat-tab label="Ultimos 5 finalizados">
    <last-cases-finished></last-cases-finished>
  </mat-tab>
  <mat-tab label="Ultimos 5 rechazados">
    <alert-last-refused></alert-last-refused>
  </mat-tab>
</mat-tab-group>
